<div *ngIf="!isWizard">
    <div class="sub-header">{{'onboarding.update_ascend_config' | translate}}</div>
    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'onboarding.ascend.dealer_id' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <hub-input [(ngModel)]="config.DealerID" [isDisabled]="true"></hub-input>
            </div>
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'onboarding.ascend.location_id' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <hub-input [(ngModel)]="config.LocationID" [isDisabled]="true"></hub-input>
            </div>
        </div>
    </div>
    <div class="row margin-top-8">
        <div class="col-md-4 label">
            {{'onboarding.ascend.account_number' | translate}}:
        </div>
        <div class="col-md-8">
            <div class="p-inputgroup">
                <hub-input [(ngModel)]="config.AccountNumber" [isDisabled]="true"></hub-input>
            </div>
        </div>
    </div>


</div>